<template>
	<div class="InvoiceDetails " >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-fapiaoguanli Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text" v-if=" only== '1' ">/ 发票管理 / 发票详情</span>
			<span class="header_text" v-if=" only== '2' ">/ 发票管理 / 发票申请</span>
		</div>
		<div class="content_Box box-shadow m-t-15 p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<el-collapse v-model="activeNames">
				<el-collapse-item name="1" class="clear">
					<template slot="title">
						<b class="font-16 p-l-5">发票信息</b>
					</template>
					<div class="contentDetailBox onebox clear">
						<div class="row-info clear ">
							<div class="fl title-key"><span>发票抬头：</span></div>
							<div class="fl list-cont"><span>{{invoiceInfo.enterprise_name}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>纳税人识别号：</span></div>
							<div class="fl list-cont font-Tahoma"><span>{{invoiceInfo.unified_credit_code}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>地 址、电 话：</span></div>
							<div class="fl list-cont font-Tahoma"><span>{{invoiceInfo.invoice_address}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>开户行及账号：</span></div>
							<div class="fl list-cont font-Tahoma"><span>{{invoiceInfo.invoice_bank}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>发票类型：</span></div>
							<div class="fl list-cont">
								<span v-if="invoiceInfo.invoice_type=='1'">增值税普通发票</span>
								<span v-if="invoiceInfo.invoice_type=='2'">增值税专用发票</span>
							</div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><i class="zb zb-asterisk"></i><span>发票类目：</span></div>
							<div class="fl list-cont" v-if="only== '1' "><span>{{invoiceInfo.name}}</span></div>
							<div class="fl list-cont" v-if="only== '2' ">
								<el-select v-model="cate_id" filterable placeholder="请选择发票类目" style="width: 300px;">
									<el-option v-for="item in invoiceList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>发票金额：</span></div>
							<div class="fl list-cont font-consolas"><span>{{invoiceInfo.settlement_money}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>对应项目名称：</span></div>
							<div class="fl list-cont">
								<span @click="gotToProjectList" class="cursor-pointer font-underline text-color-blue">{{invoiceInfo.pname}}</span>
							</div>
						</div>
						<div class="row-info clear row_addrBox clear" v-if="only== '2' ">
							<div class="fl title-key"><i class="zb zb-asterisk"></i><span>选择地址：</span></div>
							<div class="fl list-cont">
								<template>
								  <p v-for="(item,index) in invoiceAddrArr">
									  <el-radio v-model="selectInvoiceAddr" :label="item.id">
										 {{item.name}} - {{item.mobile}} - {{item.province}} - {{item.city}} - {{item.district}}{{item.detail}}
									  </el-radio>
								  </p>
								</template>
							</div>
						</div>
						<div class="clear"></div>
						<div class="row-info clear row_ImgBox" v-if="only== '1' && invoiceInfo.status== '2' ">
							<div class="fl title-key"><span>发票照片：</span></div>
							<div class="fl list-cont">
								<img :src="invoiceInfo.invoice_img" alt="" title="点击查看原图" @click="openMaxImg(invoiceInfo.invoice_img)">
							</div>
						</div>
					</div>
					
				</el-collapse-item>
				<el-collapse-item name="2" v-if="only== '1' && invoiceInfo.status== '2'">
					<template slot="title">
						<b class="font-16 p-l-5">快递信息</b>
					</template>
					<div class="contentDetailBox onebox">
						<div class="row-info clear ">
							<div class="fl title-key"><span>收件人：</span></div>
							<div class="fl list-cont"><span>{{invoiceInfo.aname}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>地址：</span></div>
							<div class="fl list-cont"><span>{{invoiceInfo.address}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>手机号：</span></div>
							<div class="fl list-cont font-Tahoma"><span>{{invoiceInfo.mobile}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>物流公司：</span></div>
							<div class="fl list-cont"><span>{{invoiceInfo.logistics_company}}</span></div>
						</div>
						<div class="row-info clear ">
							<div class="fl title-key"><span>快递单号：</span></div>
							<div class="fl list-cont font-Tahoma"><span>{{invoiceInfo.courier_number}}</span></div>
						</div>
					</div>
				</el-collapse-item>
			</el-collapse>
			<div class="m-l-50 m-t-30 m-b-20">
				<span class="resetBtn" @click="goToInvoiceList">返回发票列表</span>
				<span class="btnOK" v-if="only== '2'&& invoiceInfo.status== '0' " @click="invoiceOK">确认开票</span>
				<div v-if="invoiceInfo.status== '1'" class="submitHint">
					您的发票申请成功，您可在发票列表跟踪开票进度。
				</div>
			</div>
		</div>
		<el-dialog title="图片预览" :visible.sync="dialogVisible" width="740px" :close-on-click-modal="false">
			<div style="text-align: center;">
				<el-image style="width: 100%;" id="img90" :src="dialogVisibleImg"></el-image>
			</div>
			<span slot="footer" class="dialog-footer">
				<span class="greenBtn" @click="rotateImg(1)" style="z-index: 9999;">
					<i class="zb zb-xiangzuoxuanzhuan" style="font-size: 16px;"></i>
				</span>
				<span class="greenBtn" @click="rotateImg(2)" style="z-index: 9999;">
					<i class="zb zb-xiangyouxuanzhuan" style="font-size: 16px;"></i>
				</span>
				<span class="blueBtn" @click="dialogVisible = false">关 闭</span>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'InvoiceDetails',
		data() {
			return {
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				screenHeight: document.documentElement.clientHeight,
				dialogVisible: false, //图片放大
				dialogVisibleImg: '', //放大的图片地址
				url: common.url,
				invoiceAddrArr:[],	//发票地址集合
				invoiceInfo: {}, //项目详情
				invoiceList:[],	//发票类目
				id:'', //项目id
				activeNames: ['1', '2'],
				cate_id:'',	//发票id
				logistics_company:'',	//物流公司
				courier_number:'',	//快递单号
				invoice_img:'',//发票照片
				only:'', //进入标识 1.详情   2.申请
				selectInvoiceAddr:'', //选择的地址
				rotateNumber:0, //大图旋转
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { // 判断是否登录
					window.location = 'login.html';
					return;
				}
				let obj = this.$route.query;
				this.id = obj.id;
				this.only = obj.type;
				this.getinvoiceInfo();  //获取发票详情
				this.invoiceCategoryList(); //获取类目列表
				this.AddressList(); //获取发票地址
			},
			AddressList() { //获取发票地址列表
				this.$http.post(this.url + '/zhongfy/company/AddressList').then((res) => {
					if ( res.data.code == '200') {
						this.invoiceAddrArr = res.data.data;
						for(let i = 0 ; i < this.invoiceAddrArr.length ; i++ ){
							if(this.invoiceAddrArr[i].is_default=='1'){
								this.selectInvoiceAddr = this.invoiceAddrArr[i].id;
							}
						}
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},

			getinvoiceInfo() { //获取发票详情
				let fn = new FormData();
				fn.append('id', this.id); //发票id
				this.$http.post(this.url + '/zhongfy/company/invoiceDetail', fn).then((res) => {
					if (res.data.code == '200') {
						this.invoiceInfo = res.data.data;
						if(this.invoiceInfo.invoice_img =='http://admin.zfy.drkjjt.com/images/'){
							this.invoiceInfo.invoice_img = '';
						}
						
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			invoiceCategoryList() { //获取类目列表
				this.$http.post(this.url + '/zhongfy/company/invoiceCategoryList').then((res) => {
					if ( res.data.code == '200') {
						this.invoiceList = res.data.data;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			gotToProjectList(){
				this.$router.push('/projectManage');
			},
			invoiceOK(){  //确认开票
				if(this.cate_id==''){
					this.$message.error('请选择开票类目！');
					return;
				}
				if(this.selectInvoiceAddr==''){
					this.$message.error('请选择地址！');
					return;
				}
				let fn = new FormData();
				fn.append('id', this.id); //发票id
				fn.append('address_id', this.selectInvoiceAddr); //地址ID
				fn.append('cate_id', this.cate_id); //类目ID
				this.$http.post(this.url + '/zhongfy/company/invoiceSave',fn).then((res) => {
					if ( res.data.code == '200') {
						this.getinvoiceInfo();
						return;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			goToInvoiceList() {
				this.$router.push('/invoiceList');
			},
			openMaxImg(url) { //点击放大
				this.dialogVisible = true;
				this.dialogVisibleImg = url;
				$("#img90").css({ transform:'rotate(0deg)',width:"700px",height:'auto' });
			},
			rotateImg(type){
				console.log(type);
				if(type==1){
					let num = 90;
					this.rotateNumber -= num;
					if(this.rotateNumber == -360){
						this.rotateNumber = 0;
					}
					if( this.rotateNumber == -90 || this.rotateNumber == -270 || this.rotateNumber == 90 || this.rotateNumber == 270  ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',height:"700px",width:'auto' });
						
					}
					if( this.rotateNumber == -180 || this.rotateNumber == 180 || this.rotateNumber == 0 ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',width:"700px",height:'auto' });
					}
				}else if(type==2){
					let num = 90;
					this.rotateNumber += num;
					if(this.rotateNumber == 360){
						this.rotateNumber = 0;
					}
					if(this.rotateNumber == -90 || this.rotateNumber == -270 || this.rotateNumber == 90 || this.rotateNumber == 270 ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',height:"700px",width:'auto' });
						
					}
					if( this.rotateNumber == -180 || this.rotateNumber == 180 || this.rotateNumber == 0 ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',width:"700px",height:'auto' });
					}
				}
				
			},
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.contentDetailBox {padding: 20px;}
	.contentDetailBox .row_box {min-height: 45px;}
	.contentDetailBox .row_ImgBox {height: 200px;}
	.contentDetailBox .row_ImgBox img {height: 150px;border: 3px solid #E8E8E8;padding: 5px;}
	.contentDetailBox .up_ImgBox {min-height: 100px;}
	.contentDetailBox .up_ImgBox img {height: 100px;border: 3px solid #E8E8E8;padding: 5px;}
	.zb-asterisk {font-size: 10px;color: var(--theme-red);}
	.submitHint {text-align: left;color: #D0121B;font-size: 13px;margin-bottom: 20px;border: 1px solid red;width: 350px;padding: 10px;background-color: #f7de20;margin: 30px 0 30px 0;border-radius: 5px;}	
	.row-info .title-key{width: 90px;}	
	@media (max-width:767.78px) {
		.titleBox {height: 40px;}

	}
</style>



// WEBPACK FOOTER //
// src/components/InvoiceDetail.vue